/* eslint react/prefer-stateless-function: 0 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getStatusLabels } from '../selection';

class FilterStatus extends PureComponent {
    render() {
        const labels = getStatusLabels(this.props.categories);

        return (
            <h2 className="cmn-filter__status">
                {Object.values(labels)
                    .filter(label => (label && label !== 'No filter'))
                    .join(', ')
                }
            </h2>
        );
    }
}

const strOrNum = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
FilterStatus.propTypes = {
    categories: PropTypes.shape({
        options: PropTypes.arrayOf(PropTypes.shape({
            value: strOrNum.isRequired,
            label: strOrNum.isRequired,
            statusLabel: strOrNum
        })),
    }).isRequired
};

export default FilterStatus;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/components/FilterStatus.jsx